export default __webpack_public_path__ + "static/media/Kris Vijay.d1883e79.jpg";